import { FunctionComponent, memo } from 'react';
import {
  StoryCardAudioContent,
  StoryCardImageContent,
  StoryCardPdfContent,
  StoryCardVideoContent,
} from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedCardWrapper } from '../HorizontalStoryFeedCardWrapper';

export const HorizontalStoryFeedMedia: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;
    const { headline, subHeadline, sourceName, text, textHTML } = content as
      | StoryCardImageContent
      | StoryCardAudioContent
      | StoryCardVideoContent
      | StoryCardPdfContent;

    return (
      <HorizontalStoryFeedCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          source={sourceName}
          title={headline}
          subTitle={subHeadline}
          text={text}
          htmlText={textHTML}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedCardWrapper>
    );
  }
);
